import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { DashboardOverview } from './DashboardOverview';
import { ContactsView } from './ContactsView';
import { SuccessStoriesView } from './SuccessStoriesView';
import { GuidesView } from './GuidesView';
import { FaqView } from './FaqView';
import { FranchisesView } from './FranchisesView';
import { JobsView } from './JobsView';
import { DelegationsView } from './DelegationsView';
import { PricesView } from './PricesView';


interface DashboardProps {
    onLogout: () => void;
}

type ActiveView = 'overview' | 'contacts' | 'users' | 'success-stories' | 'guides' | 'faq' | 'franchises' | 'jobs' | 'delegations' | 'prices';

const UsersView: React.FC = () => (
    <div className="p-8">
        <h1 className="text-2xl font-bold text-gray-800">Gestión de Usuarios</h1>
        <p className="mt-4 text-gray-600">
            Esta sección está en desarrollo. Aquí podrás gestionar los usuarios registrados, sus roles y permisos.
        </p>
    </div>
);

export const Dashboard: React.FC<DashboardProps> = ({ onLogout }) => {
    const [activeView, setActiveView] = useState<ActiveView>('overview');

    const renderContent = () => {
        switch (activeView) {
            case 'overview':
                return <DashboardOverview />;
            case 'contacts':
                return <ContactsView />;
            case 'users':
                return <UsersView />;
            case 'success-stories':
                return <SuccessStoriesView />;
            case 'guides':
                return <GuidesView />;
            case 'faq':
                return <FaqView />;
            case 'franchises':
                return <FranchisesView />;
            case 'jobs':
                return <JobsView />;
            case 'delegations':
                return <DelegationsView />;
            case 'prices':
                return <PricesView />;
            default:
                return <DashboardOverview />;
        }
    };
    
    return (
        <div className="flex h-screen bg-gray-100 font-sans">
            <Sidebar activeView={activeView} setActiveView={setActiveView} onLogout={onLogout} />
            <div className="flex-1 flex flex-col overflow-hidden">
                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100">
                    <div className="container mx-auto px-6 py-8">
                        {renderContent()}
                    </div>
                </main>
            </div>
        </div>
    );
};